import { DEFAULT_LABEL_SIZE } from "./sizes";
import type { LabelBuildOptions, LabelSizeId, StorageBinLabelData } from "../types";
import { renderZplTemplate } from "./renderTemplate";
import template76x51 from "./templates/storage-bin-76x51.zpl?raw";
import template100x50 from "./templates/storage-bin-100x50.zpl?raw";
import template102x76 from "./templates/storage-bin-102x76.zpl?raw";
import template56x25 from "./templates/storage-bin-56x25.zpl?raw";

export const STORAGE_BIN_TEMPLATE_SIZES: readonly LabelSizeId[] = ["76x51", "56x25", "100x50", "102x76"] as const;

/** Placeholders used by every storage-bin template — keep in sync with the template files. */
export const STORAGE_BIN_PLACEHOLDERS = ["binCode", "locationName", "description", "footer", "qrValue"] as const;

const TEMPLATES: Partial<Record<LabelSizeId, string>> = {
  "76x51": template76x51,
  "100x50": template100x50,
  "102x76": template102x76,
  "56x25": template56x25,
};

export function renderStorageBinZpl(
  data: StorageBinLabelData,
  size: LabelSizeId = DEFAULT_LABEL_SIZE,
  options: LabelBuildOptions = {},
): string {
  const template = options.zplTemplate ?? TEMPLATES[size] ?? TEMPLATES[DEFAULT_LABEL_SIZE]!;
  return renderZplTemplate(
    template,
    {
      binCode: data.binCode,
      locationName: data.locationName || "—",
      description: data.description || "",
      footer: data.footer ?? "",
      qrValue: data.qrValue,
    },
    { allowedPlaceholders: STORAGE_BIN_PLACEHOLDERS },
  );
}
